import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { Overlay, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { PopoverComponent } from './popover.component';
import { TooltipPosition, TooltipPositioning } from '../tooltip/tooltip.enum';

@Directive({
    selector: '[u4Popover]'
})
export class PopoverDirective implements OnInit, OnDestroy {

    @Input('u4Popover') content: TemplateRef<any> = null;
    @Input('u4PopoverOffset') offset = 14;
    @Input('u4PopoverPosition') position: string = TooltipPosition.SOUTHWEST;
    @Input('u4PopoverBackdrop') backdrop = true;

    private overlayRef: OverlayRef;

    constructor(
        private overlay: Overlay,
        private overlayPositionBuilder: OverlayPositionBuilder,
        private elementRef: ElementRef
    ) {}
    
    get isActive(): boolean {
        return this.overlayRef.hasAttached();
    }
    
    @HostListener('document:click', ['$event'])
    clickHandler(event: MouseEvent) {
        if (this.isActive && !this.overlayRef.overlayElement.contains(event.target  as HTMLElement)) {
            this.hide();
        }
    }
    
    @HostListener('click', ['$event'])
    toggle(event: MouseEvent) {
        if (this.isActive) {
            this.hide();
        } else {
            this.show();
        }

        event.stopPropagation();
    }

    
    ngOnInit(): void {
        const position = {
            ...TooltipPositioning[this.position],
            offsetY: this.position.includes('north') ? -this.offset : this.offset
        };

        const scrollStrategy = this.overlay.scrollStrategies.close();
        const positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(this.elementRef)
            .withPositions([position]);

        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy,
            hasBackdrop: this.backdrop
        });
    }


    ngOnDestroy() {
        this.hide();
        this.overlayRef.dispose();
    }


    show() {
        const popoverRef = this.overlayRef.attach(
            new ComponentPortal(PopoverComponent)
        );

        popoverRef.instance.content = this.content;
        popoverRef.instance.direction = this.position as TooltipPosition;
    }

    hide() {
        this.overlayRef.detach();
    }
}
